import { useStripe } from 'core/contexts/stripe';
import { EmbeddedCheckout, EmbeddedCheckoutProvider } from '@stripe/react-stripe-js';

const StripeForm = ({ open = false, clientSecret }) => {
    const { stripePromise } = useStripe();

    const fetchClientSecret = () => clientSecret;
    const options = { fetchClientSecret };

    if (!open || !stripePromise) return null;

    return (
        <div id="checkout">
            <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
                <EmbeddedCheckout />
            </EmbeddedCheckoutProvider>
        </div>
    );
};

export default StripeForm;
